import initEmailSignup from "../initEmailSignup.js";
import initEmailSticky from "../initEmailSticky.js";
import renderEmailSignupModal from "../renderEmailSignupModal.jsx";
import scTracking from "../../../components/SCTracking/sc-tracking.js";
document.addEventListener("DOMContentLoaded", () => {
  initEmailSignup();
  initEmailSticky();
  renderEmailSignupModal();

  // SC tracking for email signup, Stage 1
  document.querySelectorAll(".js-sc-email-signup1").forEach((elm) => {
    elm.addEventListener("submit", (e) => {
      scTracking("email1", {
        email: e.target.querySelector(".js-email-signup-input").value,
        goal: e.target.getAttribute("data-goal"),
      });
    });
  });

  // SC tracking for email signup, Stage 2
  document.querySelectorAll(".js-sc-email-signup2").forEach((elm) => {
    elm.addEventListener("click", (e) => {
      scTracking("email2", {
        goal: e.target
          .closest(".email-signup__button-row")
          .getAttribute("data-goal"),
      });
    });
  });
});
